export interface DateTimeStyles {
  style?: React.CSSProperties;
}

export const styles: DateTimeStyles = {
  style: {
    width: '100%',
    fontFamily: 'Avenir',
    textAlign: 'center',
    paddingTop: '4px',
    paddingBottom: '10px',
    fontSize: '15px',
    color: 'rgba(0, 0, 0, .40)',
  },
};
